export default [
    {
        path: '/',
        name: 'betting_dashboard',
        component: () => import('@/components/Betting/Dashboard.vue'),
        meta: {
            title: 'Dashboard - Codifyo Betting',
            requiresAuth: true,
            requiredRole: 'ROLE_BETTING'
        }
    },
    {
        path: '/login',
        name: 'betting_login',
        component: () => import('@/components/Betting/Login.vue'),
        meta: {
            title: 'Connexion - Codifyo Betting',
            requiresAuth: false
        }
    },
    {
        path: '/settings',
        name: 'betting_settings',
        component: () => import('@/components/Betting/CompetitionSettings.vue'),
        meta: {
            title: 'Configuration - Codifyo Betting',
            requiresAuth: true,
            requiredRole: 'ROLE_BETTING'
        }
    },
    {
        path: '/predictions',
        name: 'betting_predictions',
        component: () => import('@/components/Betting/PredictionsDashboard.vue'),
        meta: {
            title: 'Pronostics IA - Codifyo Betting',
            requiresAuth: true,
            requiredRole: 'ROLE_BETTING'
        }
    }
];
